const ITEMS = [
  "100% HIPAA Compliant",
  "Epic & AthenaHealth Certified",
  "99.4% Client Retention Rate",
  "48-Hour Rapid Onboarding",
  "US-Based Dedicated Management",
  "Cerner & eClinicalWorks Ready",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      className="relative overflow-hidden border-y border-[#0F1E19]/10 bg-[#0A3B2C] py-4"
      data-testid="trust-marquee"
    >
      <div className="animate-marquee flex w-max items-center">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-mono text-xs sm:text-sm font-medium uppercase tracking-[0.25em] text-[#F5F7F6]/90">
              {item}
            </span>
            <span className="mx-8 text-[#EAB308]">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
